
const H264Decoder = function(opts) {
    this._ctor(opts);
};

const pt = H264Decoder.prototype;

pt._ctor = function(opts) {
    opts = opts || {};
    
    const self = this;
    const useWorker = this.useWorker = opts.useWorker || false;
    const workerFile = this.workerFile = opts.workerFile || '/lib/broadway/Decoder.js';
    const rgb = this.rgb = opts.rgb || false;
    const memsize = this.memsize = opts.memsize;
    const reuseMemory = this.reuseMemory = opts.reuseMemory || false;
    const transferMemory = this.transferMemory = opts.transferMemory || false;
    if (useWorker){
        const worker = this.$worker = new Worker(workerFile);
        this.worker = worker;
        worker.addEventListener('message', function(e) {
          var data = e.data;
          if (data.consoleLog){
            console.debug(data.consoleLog);
            return;
          } 
          let dataArray = new Uint8Array(data.buf, 0, data.length);
          self.onDecoded.call(self,
            dataArray,
            data.width,
            data.height,
            data.infos);
          
          self.recycleMemory(dataArray);

        }, false);
        
        worker.postMessage({type: "Broadway.js - Worker init", options: {
          rgb: rgb,
          memsize: memsize,
          reuseMemory: !!reuseMemory
        }});
        
        if (transferMemory){
          this.decode = function(parData, parInfo){
            // no copy
            // instead we are transfering the ownership of the buffer
            // dangerous!!!
            worker.postMessage({
                buf: parData.buffer,
                offset: parData.byteOffset,
                length: parData.length,
                info: parInfo
            }, [parData.buffer]); // Send data to our worker.
          };
          
        }else{
          this.decode = function(parData, parInfo){
            // Copy the sample so that we only do a structured clone of the
            // region of interest
            var copyU8 = new Uint8Array(parData.length);
            copyU8.set( parData, 0, parData.length );
            worker.postMessage({
                buf: copyU8.buffer,
                offset: 0,
                length: parData.length,
                info: parInfo
            }, [copyU8.buffer]); // Send data to our worker.
          };
          
        }
        
        if (reuseMemory){
          this.recycleMemory = function(parArray){
            //this.beforeRecycle();
            worker.postMessage({
                reuse: parArray.buffer
            }, [parArray.buffer]); // Send data to our worker.
            //this.afterRecycle();
          };
        }
        
      }else{
        
        throw new Error('H264Decoder must be run in worker');

        // this.decoder = new Decoder({
        //   rgb: rgb
        // });
        // this.decoder.onPictureDecoded = function(data, width, height, infos) {
        //     self.onDecoded.call(self,
        //         data, width, height, infos);
        // };
        // 
        // this.decode = function(parData, parInfo){
        //   self.decoder.decode(parData, parInfo);
        // };
        
      }
};

pt.destroy = function() {
    if (this.worker) {
        this.worker.terminate();
        this.worker = null;
    }
};

pt.recycleMemory = function() {};

pt.onDecoded = function() {};

export default H264Decoder;
